import { AlertColor } from '@mui/material';
import { IconBaseProps } from 'react-icons';
import { FaCheckCircle, FaExclamationCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

export interface AlertIconProps extends IconBaseProps {
  severity?: AlertColor;
}

export function AlertIcon({ severity, ...iconProps }: AlertIconProps) {
  switch (severity) {
    case 'error':
      return <FaExclamationCircle {...iconProps} />;
    case 'warning':
      return <FaExclamationTriangle {...iconProps} />;
    case 'success':
      return <FaCheckCircle {...iconProps} />;
    case 'info':
      return <FaInfoCircle {...iconProps} />;
    default:
      return null;
  }
}
